<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label=" Page viii. " class="page" epub:type="pagebreak" id="pviii" role="doc-pagebreak"></span><span aria-label=" Page ix. " class="page" epub:type="pagebreak" id="pix" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfm" id="rfore"><a class="xref" href="#/wsugallagher0010#fore">Foreword</a></p>
<p class="tocf" id="rch01"><a class="xref" href="#/wsugallagher0011#ch01">1. Ashes to Ashes</a></p>
<p class="toc" id="rch02"><a class="xref" href="#/wsugallagher0012#ch02">2. Beginnings</a></p>
<p class="toc" id="rch03"><a class="xref" href="#/wsugallagher0013#ch03">3. Chicago Reporter</a></p>
<p class="toc" id="rch04"><a class="xref" href="#/wsugallagher0014#ch04">4. Upstate New York</a></p>
<p class="toc" id="rch05"><a class="xref" href="#/wsugallagher0015#ch05">5. My New York Year</a></p>
<p class="toc" id="rch06"><a class="xref" href="#/wsugallagher0016#ch06">6. Inside the Pyramid</a></p>
<p class="toc" id="rch07"><a class="xref" href="#/wsugallagher0017#ch07">7. Getting to Detroit</a></p>
<p class="toc" id="rch08"><a class="xref" href="#/wsugallagher0018#ch08">8. <i>Detroit Free Press</i></a></p>
<p class="toc" id="rch09"><a class="xref" href="#/wsugallagher0019#ch09">9. Union Activist</a></p>
<p class="toc" id="rch10"><a class="xref" href="#/wsugallagher0020#ch10">10. On Strike</a></p>
<p class="toc" id="rch11"><a class="xref" href="#/wsugallagher0021#ch11">11. The <i>Detroit Sunday Journal</i></a></p>
<p class="toc" id="rch12"><a class="xref" href="#/wsugallagher0022#ch12">12. Newspapers in Transition</a></p>
<p class="toc" id="rch13"><a class="xref" href="#/wsugallagher0023#ch13">13. Detroit and the Urban Dilemma</a></p>
<p class="toc" id="rch14"><a class="xref" href="#/wsugallagher0024#ch14">14. Cities: A Recovery Begins</a></p>
<p class="toc" id="rch15"><a class="xref" href="#/wsugallagher0025#ch15">15. Writing Books</a></p>
<p class="toc" id="rch16"><a class="xref" href="#/wsugallagher0026#ch16">16. A City in Bankruptcy</a></p>
<p class="toc" id="rch17"><a class="xref" href="#/wsugallagher0027#ch17">17. An Aside: On Never Winning a Pulitzer</a></p>
<p class="toc" id="rch18"><a class="xref" href="#/wsugallagher0028#ch18">18. Union President</a></p>
<p class="toc" id="rch19"><span aria-label=" Page x. " class="page" epub:type="pagebreak" id="px" role="doc-pagebreak"></span><a class="xref" href="#/wsugallagher0029#ch19">19. Pension Trustee</a></p>
<p class="toc" id="rch20"><a class="xref" href="#/wsugallagher0030#ch20">20. Negotiations</a></p>
<p class="toc" id="rch21"><a class="xref" href="#/wsugallagher0031#ch21">21. Columns and Flash Fiction</a></p>
<p class="toc" id="rch22"><a class="xref" href="#/wsugallagher0032#ch22">22. Detroit: The Recovery</a></p>
<p class="toc" id="rch23"><a class="xref" href="#/wsugallagher0033#ch23">23. When It’s Time to Move On</a></p>
<p class="tocbmf" id="raubio"><a class="xref" href="#/wsugallagher0034#aubio">About the Author</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-gallagher-0009.vue?095c2004